import React, { useEffect, useState } from "react";
import TableContainer from "../../../Component/TableContainer";
import {
    Box,
    Checkbox,
    Dialog,
    IconButton,
    Typography,
    Paper,
    Grid,
    Button,
    Select,
    MenuItem,
    Switch,
    Autocomplete,
    CircularProgress,
    createFilterOptions,
    TextField,
} from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { masterAPI } from "../dataConfig";
import { axiosPrivate } from "../../../axios/axios";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import {
    CheckCircle,
    DeleteOutline,
    EditOffOutlined,
    EditOutlined,
    RadioButtonUncheckedOutlined,
} from "@mui/icons-material";
import { color } from "../../../StyleData/Config";
import RoleMenuModal from "./RoleMenuModal";
import NormalTable from "../../../Component/NormalTable";
import { useSelector } from "react-redux";
import { defaultInfo, DashboardIds, SubMenu, isSystemAccess } from "../../../ConfigInfo/Info";

const RoleMenu = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const login = useSelector((state) => state.auth.loginInfo);

    const eamAdmin = login?.roleName === defaultInfo.roleName.eamSuperAdmin;

    const [loading, setLoading] = useState(false);
    const [menusId, setMenusId] = useState([]);
    const [backupMenu, setBackUpMenu] = useState([]);
    const [rolesId, setRolesId] = useState([]);
    const [alreadyHaveMenu, setAlreadyHaveMenu] = useState([]);
    const [originalPermissions, setOriginalPermissions] = useState({});
    const [sel, setSel] = useState({
        autoRole: "",
        selectedRole: "",
        selectmenuId: [],
        selectedDetails: [],
        roleDetail: null,
        autoOrg: eamAdmin ? "" : login.organizationName,
        autoSite:"",
        siteDetail:eamAdmin?defaultInfo.site:null
    });
    const [org, setOrgId] = useState([]);
    const [site, setSiteId] = useState([]);
    const [idInfo, setIdInfo] = useState({
        orgid: eamAdmin ? null : login.organizationId,
        siteid: eamAdmin?defaultInfo.site.id:null,
    });
    useEffect(() => {
        getData();
        // getMenu();
    }, []);

    const OPTIONS_LIMIT = 10;
    const defaultFilterOptions = createFilterOptions();

    const filterOptions = (options, state) => {
        return defaultFilterOptions(options, state);
    };
    const CustomPaper = (props) => {
        return <Paper elevation={8} {...props} />;
    };

    const getData = async () => {
        setLoading(true);

         if(eamAdmin){


           const orglink = masterAPI["organization"].link;
         await axiosPrivate
           .get(`${orglink}`)
           .then((res) => {
             setLoading(false);
             setOrgId(res.data.result);
           })
           .catch((e) => {
             setOrgId([]);
             setLoading(false);
             console.log(e, "orgError");
           });
         }else{
        getMenu(login.organizationId)
        getSite(login.organizationId)

        setOrgId([{id:login.organizationId,organizationName:login.organizationName,code:login.organizationCode || ""}]);
         }
        getRole()



    };

    const getRole=( id)=>{
        const roleLink = masterAPI["roles"].link;
        axiosPrivate
            .get(`${roleLink}`)
            .then((res) => {
                setRolesId(res.data.result);
            })
            .catch((e) => {
                setRolesId([]);
                console.log(e, "createrolesgetAll");
            });
    }

    const getSite = async (id) => {
        const link = masterAPI["site"].getallByOrgid;
        await axiosPrivate
            .get(`${link}/${id}`)
            .then((res) => {
                console.log(res)
                setLoading(false);
                setSiteId(res.data.result);
            })
            .catch((e) => {
                setSiteId([]);
                setLoading(false);
                console.log(e, "siteerror");
            });
    };

    const getMenu = async (id) => {
        if(id===defaultInfo.organization.id){
            const menuLink = masterAPI["menus"].getMasterMenus;
            axiosPrivate
                .get(`${menuLink}`)
                .then((res) => {
                    console.log(res)
                    setLoading(false);
                    setMenusId(res.data.result);
                    setBackUpMenu(res.data.result);
                    console.log("menu", res.data.result);
                })
                .catch((e) => {
                    setMenusId([]);
                    setBackUpMenu([]);
                    console.log(e, "menuError");
                });
        }else{
            const menuLink = masterAPI["menus"].getallMenuByOrgid;
            axiosPrivate
                .get(`${menuLink}/${id}`)
                .then((res) => {
                    setLoading(false);
                    setMenusId(res.data.result);
                    setBackUpMenu(res.data.result);
                    console.log("menu", res.data.result);
                })
                .catch((e) => {
                    setMenusId([]);
                    setBackUpMenu([]);
                    console.log(e, "menuError");
                });
        }

    };
    const getMenuBySite = (id) => {
        const menuLink = masterAPI["menus"].getBySitId;
        axiosPrivate
            .get(`${menuLink}/${id}`)
            .then((res) => {
                setLoading(false);
                setMenusId(res.data.result);
                setBackUpMenu(res.data.result);
                console.log("sitemenu", res.data.result);
            })
            .catch((e) => {
                setMenusId([]);
                setBackUpMenu([]);
                console.log(e, "menuError");
            });
    };
    const isDashboardMenu = (id) => Object.values(DashboardIds).includes(id);
    const isWorkOrderCloseMenu = (id) => id === SubMenu.workOrderClose;
    // const handleSwitch = (e, menuValue, name) => {
    //   console.log(e.target.checked, menuValue);
    //   const storeAction = [];
    //   for (let i = 0; menusId.length > i; i++) {
    //     if (menusId[i].id === menuValue.id) {
    //       storeAction.push({ ...menusId[i], [name]: e.target.checked });
    //     } else {
    //       storeAction.push(menusId[i]);
    //     }
    //   }
    //   setMenusId(storeAction);
    // };
    // const updateMyData = (rowIndex, columnId, value) => {
    //   setMenusId(
    //     menusId.map((row, index) => {
    //       if (index === rowIndex) {
    //         return { ...row, [columnId]: value };
    //       }
    //       return row;
    //     })
    //   );
    // };
    // const handleCheck = (e, menuValue) => {
    //   if (e.target.checked) {
    //     setSel({
    //       ...sel,
    //       selectmenuId: [...sel.selectmenuId, menuValue.id],
    //       selectedDetails: [
    //         ...sel.selectedDetails,
    //         {
    //           menuId: menuValue.id,
    //           roleId: sel.selectedRole,
    //           view: menuValue.view !== undefined ? menuValue.view : false,
    //           create: menuValue.create !== undefined ? menuValue.create : false,
    //           edit: menuValue.edit !== undefined ? menuValue.edit : false,
    //           delete: menuValue.delete !== undefined ? menuValue.delete : false,
    //           organizationId: idInfo.orgid,
    //           siteId: idInfo.siteid,
    //           id: sel.selectedDetails,
    //         },
    //       ],
    //     });
    //   } else {
    //     const filselectId = sel.selectmenuId.filter(
    //       (fil) => fil !== menuValue.id
    //     );
    //     const filselectDetails = sel.selectedDetails.filter(
    //       (fil) => fil.menuId !== menuValue.id
    //     );

    //     // Also remove from alreadyHaveMenu if it exists there
    //     const updatedAlreadyHaveMenu = alreadyHaveMenu.filter(
    //       (id) => id !== menuValue.id
    //     );

    //     setSel({
    //       ...sel,
    //       selectmenuId: filselectId,
    //       selectedDetails: filselectDetails,
    //     });
    //     setAlreadyHaveMenu(updatedAlreadyHaveMenu);
    //   }
    // };

    //   const handleCheck = (e, menuValue) => {
    //   if (e.target.checked) {
    //     setSel({
    //       ...sel,
    //       selectmenuId: [...sel.selectmenuId, menuValue.id],
    //       selectedDetails: [
    //         ...sel.selectedDetails,
    //         {
    //           menuId: menuValue.id,
    //           roleId: sel.selectedRole,
    //           view: menuValue.view !== undefined ? menuValue.view : false,
    //           create: menuValue.create !== undefined ? menuValue.create : false,
    //           edit: menuValue.edit !== undefined ? menuValue.edit : false,
    //           delete: menuValue.delete !== undefined ? menuValue.delete : false,
    //           organizationId: idInfo.orgid,
    //           siteId: idInfo.siteid,
    //         },
    //       ],
    //     });
    //   } else {
    //     const filselectId = sel.selectmenuId.filter(
    //       (fil) => fil !== menuValue.id
    //     );
    //     const filselectDetails = sel.selectedDetails.filter(
    //       (fil) => fil.menuId !== menuValue.id
    //     );
    //     setSel({
    //       ...sel,
    //       selectmenuId: filselectId,
    //       selectedDetails: filselectDetails,
    //     });
    //   }
    // };

    const columns = [
        {
            accessor: "id",
            disableFilters: true,
            Cell: ({ cell }) => {
                // Check if the item is either selected or was previously assigned
                const wasPreviouslyAssigned = alreadyHaveMenu.includes(cell.value);
                const isCurrentlySelected = sel.selectmenuId.includes(cell.value);

                // Item should be checked if it's either currently selected OR was previously assigned but not deselected
                const isChecked =
                    isCurrentlySelected ||
                    (wasPreviouslyAssigned &&
                        !sel.selectedDetails.some(
                            (item) => item.menuId === cell.value && item.IsDeleted
                        ));

                return (
                    <Box sx={{ width: color.checkBoxWidth }}>
                        <Checkbox
                            checked={isChecked}
                            onChange={(e) =>
                                handleCheck(e, cell.row.original, wasPreviouslyAssigned)
                            }
                        />
                    </Box>
                );
            },
        },

        {
            Header: "Menu Name",
            accessor: "name",
        },
        {
            Header: "Parent Menu",
            accessor: "parentMenuName",
        },
        {
            Header: "View",
            accessor: "view",
            disableFilters: true,
            Cell: ({ cell, row }) => {
                // const wasPreviouslyAssigned = !alreadyHaveMenu.includes(cell.value);
                const isCurrentlySelected = !sel.selectmenuId.includes(cell.row.original.id);
                const isCloseMenu = isWorkOrderCloseMenu(cell.row.original.id);
                // console.log(cell)
                return (
                    <Switch
                        sx={{ ml: -2 }}
                        disabled={isCurrentlySelected || isCloseMenu}
                        checked={isCloseMenu ? false : cell.value !== undefined && cell.value}
                        onChange={(e) => {
                            if (!isCloseMenu) handleSwitch(e, cell.row.original, "view");
                        }}
                    />
                );
            },
        },
        {
            Header: "Create",
            accessor: "create",
            disableFilters: true,
            Cell: ({ cell, row }) => {
                const isCurrentlySelected = !sel.selectmenuId.includes(cell.row.original.id);
                const isDash = isDashboardMenu(cell.row.original.id);
                const isCloseMenu = isWorkOrderCloseMenu(cell.row.original.id);
                return (
                    <Switch
                        sx={{ ml: -2 }}
                        disabled={isCurrentlySelected || isDash || isCloseMenu}
                        checked={isDash || isCloseMenu ? false : cell.value !== undefined && cell.value}
                        onChange={(e) => {
                            if (!isDash && !isCloseMenu) handleSwitch(e, cell.row.original, "create");
                        }}
                    />
                );
            },
        },
        {
            Header: "Edit",
            accessor: "edit",
            disableFilters: true,
            Cell: ({ cell }) => {
                const isCurrentlySelected = !sel.selectmenuId.includes(cell.row.original.id);
                const isDash = isDashboardMenu(cell.row.original.id);
                return (
                    <Switch
                        sx={{ ml: -2 }}
                        disabled={isCurrentlySelected || isDash}
                        checked={isDash ? false : cell.value !== undefined && cell.value}
                        onChange={(e) => {
                            if (!isDash) handleSwitch(e, cell.row.original, "edit");
                        }}
                    />
                );
            },
        },
        {
            Header: "Delete",
            accessor: "delete",
            disableFilters: true,
            Cell: ({ cell }) => {
                const isCurrentlySelected = !sel.selectmenuId.includes(cell.row.original.id);
                const isDash = isDashboardMenu(cell.row.original.id);
                const isCloseMenu = isWorkOrderCloseMenu(cell.row.original.id);
                return (
                    <Switch
                        sx={{ ml: -2 }}
                        disabled={isCurrentlySelected || isDash || isCloseMenu}
                        checked={isDash || isCloseMenu ? false : cell.value !== undefined && cell.value}
                        onChange={(e) => {
                            if (!isDash && !isCloseMenu) handleSwitch(e, cell.row.original, "delete");
                        }}
                    />
                );
            },
        },
    ];
    const handleSwitch = (e, menuValue, name) => {
        // prevent toggling create/edit/delete for dashboard menu items
        if ((name === "create" || name === "edit" || name === "delete") && isDashboardMenu(menuValue.id)) {
            return;
        }
        // work order close menu only allows editing the "edit" permission
        if ((name === "view" || name === "create" || name === "delete") && isWorkOrderCloseMenu(menuValue.id)) {
            return;
        }
        // First update the UI state
        const updatedMenus = menusId.map((menu) =>
            menu.id === menuValue.id ? { ...menu, [name]: e.target.checked } : menu
        );
        setMenusId(updatedMenus);

        // Only update selectedDetails if this menu is checked (in selectmenuId)
        if (sel.selectmenuId.includes(menuValue.id)) {
            setSel((prev) => {
                const existingItem = prev.selectedDetails.find(
                    (item) => item.menuId === menuValue.id
                );

                if (existingItem) {
                    // Update existing item
                    return {
                        ...prev,
                        selectedDetails: prev.selectedDetails.map((item) =>
                            item.menuId === menuValue.id
                                ? { ...item, [name]: e.target.checked }
                                : item
                        ),
                    };
                } else {
                    // Add new item (shouldn't happen since checkbox is checked)
                    return {
                        ...prev,
                        selectedDetails: [
                            ...prev.selectedDetails,
                            {
                                menuId: menuValue.id,
                                roleId: prev.selectedRole,
                                view: menuValue.view || false,
                                create: menuValue.create || false,
                                edit: menuValue.edit || false,
                                delete: menuValue.delete || false,
                                organizationId: idInfo.orgid,
                                siteId: idInfo.siteid,
                                [name]: e.target.checked,
                            },
                        ],
                    };
                }
            });
        }
    };

    const handleCheck = (e, menuValue, wasPreviouslyAssigned) => {
        if (e.target.checked) {
            // Add to selectedDetails with current toggle states
            setSel((prev) => ({
                ...prev,
                selectmenuId: [...prev.selectmenuId, menuValue.id],
                selectedDetails: [
                    ...prev.selectedDetails.filter(
                        (item) => item.menuId !== menuValue.id
                    ),
                    {
                        menuId: menuValue.id,
                        roleId: prev.selectedRole,
                        view: isWorkOrderCloseMenu(menuValue.id) ? false : true,
                        create: isDashboardMenu(menuValue.id) || isWorkOrderCloseMenu(menuValue.id) ? false : true,
                        edit: isDashboardMenu(menuValue.id) ? false : true,
                        delete: isDashboardMenu(menuValue.id) || isWorkOrderCloseMenu(menuValue.id) ? false : true,
                        organizationId: idInfo.orgid,
                        siteId: idInfo.siteid,
                        IsDeleted: false,
                    },
                    // {
                    //     menuId: menuValue.id,
                    //     roleId: prev.selectedRole,
                    //     view: menuValue.view || false,
                    //     create: menuValue.create || false,
                    //     edit: menuValue.edit || false,
                    //     delete: menuValue.delete || false,
                    //     organizationId: idInfo.orgid,
                    //     siteId: idInfo.siteid,
                    //     IsDeleted: false,
                    // },
                ],
            }));
            const addMenus = menusId.map((menu) =>
                menu.id === menuValue.id
                    ? {
                        ...menu,
                        view: isWorkOrderCloseMenu(menuValue.id) ? false : true,
                        create: isDashboardMenu(menuValue.id) || isWorkOrderCloseMenu(menuValue.id) ? false : true,
                        edit: isDashboardMenu(menuValue.id) ? false : true,
                        delete: isDashboardMenu(menuValue.id) || isWorkOrderCloseMenu(menuValue.id) ? false : true,
                    }
                    : menu
            );
            setMenusId(addMenus)
        } else {
            // When unchecking, reset the menu's toggle states
            const updatedMenus = menusId.map((menu) =>
                menu.id === menuValue.id
                    ? {
                        ...menu,
                        view: false,
                        create: false,
                        edit: false,
                        delete: false,
                    }
                    : menu
            );
            setMenusId(updatedMenus);

            // Remove from selectedDetails or mark for deletion
            if (wasPreviouslyAssigned) {
                setSel((prev) => ({
                    ...prev,
                    selectmenuId: prev.selectmenuId.filter((id) => id !== menuValue.id),
                    selectedDetails: [
                        ...prev.selectedDetails.filter(
                            (item) => item.menuId !== menuValue.id
                        ),
                        {
                            menuId: menuValue.id,
                            roleId: prev.selectedRole,
                            view: false,
                            create: false,
                            edit: false,
                            delete: false,
                            organizationId: idInfo.orgid,
                            siteId: idInfo.siteid,
                            IsDeleted: true,
                        },
                    ],
                }));
            } else {
                setSel((prev) => ({
                    ...prev,
                    selectmenuId: prev.selectmenuId.filter((id) => id !== menuValue.id),
                    selectedDetails: prev.selectedDetails.filter(
                        (item) => item.menuId !== menuValue.id
                    ),
                }));
            }
        }
    };

    const handleSubmit = async () => {
        setLoading(true);

        // Only include items that are actually checked (in selectmenuId)
        const dataToSend = sel.selectedDetails
            .filter((item) => sel.selectmenuId.includes(item.menuId))
            .map((item) => ({
                id:
                    originalPermissions[item.menuId]?.id ||
                    "00000000-0000-0000-0000-000000000000",
                menuId: item.menuId,
                roleId: sel.selectedRole,
                view: item.view || false,
                create: item.create || false,
                edit: item.edit || false,
                delete: item.delete || false,
                organizationId: idInfo.orgid,
                siteId: idInfo.siteid,
                isDeleted: false, // Only active items are included
            }));

        // Add items marked for deletion
        const deletions = sel.selectedDetails
            .filter((item) => item.IsDeleted)
            .map((item) => ({
                id:
                    originalPermissions[item.menuId]?.id ||
                    "00000000-0000-0000-0000-000000000000",
                menuId: item.menuId,
                roleId: sel.selectedRole,
                view: false,
                create: false,
                edit: false,
                delete: false,
                organizationId: idInfo.orgid,
                siteId: idInfo.siteid,
                isDeleted: true,
            }));

        const finalData = [...dataToSend, ...deletions];
        console.log("Final data to send:", finalData);

        try {
            const createLink = masterAPI["roleMenu"].bulkinsert;
            const response = await axiosPrivate.post(`${createLink}`, finalData);

            // Update state with response
            // const newPermissions = {};
            // response.data.result.forEach(item => {
            //   if (!item.IsDeleted) {
            //     newPermissions[item.menuId] = {
            //       id: item.id,
            //       view: item.view,
            //       create: item.create,
            //       edit: item.edit,
            //       delete: item.delete
            //     };
            //   }
            // });

            // setOriginalPermissions(newPermissions);

            handleCancel();
        } catch (error) {
            console.error("Error:", error);
        } finally {
            setLoading(false);
        }
    };
    const handleCancel = (type) => {
        setSel({
            autoRole: "",
            selectedRole: "",
            selectmenuId: [],
            selectedDetails: [],
            roleDetail: null,
            autoOrg: eamAdmin ? (type ? sel.autoOrg : "") :login.organizationName,
            autoSite: type?sel.autoSite:"",
            siteDetail:type?sel.siteDetail:null
        });
        setIdInfo({
            orgid: eamAdmin ? (type ? idInfo.orgid : null) :login.organizationId,
            siteid:type?idInfo.siteid:eamAdmin?defaultInfo.site.id:null,
        })
        setMenusId(type ? menusId :backupMenu);
        //setBackUpMenu([]);
        setAlreadyHaveMenu([]);
    };
    const getRoleMenuList=(roleValue,type,menuListByLicence)=>{
        const payLoadSearch = {
            roleId: roleValue.id,
            organizationId: idInfo.orgid,
            siteId: idInfo.siteid
        }
        console.log(payLoadSearch);
        const getbyRoleId = masterAPI["roleMenu"].getbyRoleId;
        axiosPrivate
            .post(`${getbyRoleId}`, payLoadSearch)
            .then((res) => {
                console.log("res", res);

                // Store original permissions
                const permissionsMap = {};
                res.data.result.forEach((item) => {
                    permissionsMap[item.menuId] = {
                        view: item.view,
                        create: item.create,
                        edit: item.edit,
                        delete: item.delete,
                        id: item.id,
                    };
                });
                setOriginalPermissions(permissionsMap);

                const menubackup = type?[...backupMenu]:[...menuListByLicence];
                const haveMenu = [];

                for (let i = 0; res.data.result.length > i; i++) {
                    for (let j = 0; menubackup.length > j; j++) {
                        if (menubackup[j].id === res.data.result[i].menuId) {
                            haveMenu.push(menubackup[j].id);
                            menubackup[j] = {
                                ...menubackup[j],
                                create: isDashboardMenu(menubackup[j].id) || isWorkOrderCloseMenu(menubackup[j].id)
                                    ? false
                                    : res.data.result[i].create,
                                edit: isDashboardMenu(menubackup[j].id)
                                    ? false
                                    : res.data.result[i].edit,
                                view: isWorkOrderCloseMenu(menubackup[j].id)
                                    ? false
                                    : res.data.result[i].view,
                                delete: isDashboardMenu(menubackup[j].id) || isWorkOrderCloseMenu(menubackup[j].id)
                                    ? false
                                    : res.data.result[i].delete,
                            };
                        }
                    }
                }

                setAlreadyHaveMenu(haveMenu);
                setMenusId(menubackup);
                setSel({
                    ...sel,
                    selectedRole: roleValue.id,
                    roleDetail: roleValue,
                    // Initialize selectedDetails with current permissions
                    selectmenuId:res.data.result.map((d)=>(d.menuId)),
                    selectedDetails: res.data.result.map((item) => ({
                        menuId: item.menuId,
                        roleId: roleValue.id,
                        view: isWorkOrderCloseMenu(item.menuId) ? false : item.view,
                        create: isDashboardMenu(item.menuId) || isWorkOrderCloseMenu(item.menuId) ? false : item.create,
                        edit: isDashboardMenu(item.menuId) ? false : item.edit,
                        delete: isDashboardMenu(item.menuId) || isWorkOrderCloseMenu(item.menuId) ? false : item.delete,
                        organizationId: idInfo.orgid,
                        siteId: idInfo.siteid,
                    })),
                });
            })
            .catch((e) => {
                setAlreadyHaveMenu([]);
                setSel({ ...sel, selectedRole: roleValue.id, roleDetail: roleValue });
                setMenusId(type?backupMenu:menuListByLicence);
                console.log(e);
            });
    }
    const handleRoleMenu = async (roleValue) => {

        if(eamAdmin){
            getRoleMenuList(roleValue,true)
        }else{
            const getMenuByUserType=masterAPI["licenceMenu"].getMenuByLicence
            console.log(roleValue)
            axiosPrivate.get(`${getMenuByUserType}/${roleValue.licenceUserTypeId}`).then(res=>{
                console.log(res)
                getRoleMenuList(roleValue,false,res.data.result)
            }).catch(e=>{
                console.log(e)
            })
        }



    };
    return (
        <>
            <Box>
                <Typography
                    sx={{
                        color: color.masterPageTitleColor,
                        fontSize: color.masterPageTitleFontSize,
                        fontWeight: color.masterPageTitleFontWeight,
                        mb: color.masterPageTitlemd,
                    }}
                >
                    {masterAPI["roleMenu"].title}
                </Typography>
            </Box>

            <Paper sx={{ p: 1 }}>
                <Grid container spacing={"1rem"}>
                    <Grid item xs={4}>
                        <Typography
                            sx={{
                                fontWeight: color.labelFontWeight,
                                mb: color.labelmb,
                                fontSize: color.labelFont,
                                color: color.labelColor,
                            }}
                        >
                            Organization
                        </Typography>
                        <Autocomplete
                            fullWidth
                            readOnly={!eamAdmin}
                            filterOptions={filterOptions}
                            loading={org.length === 0}
                            inputValue={sel.autoOrg}
                            options={org}
                            PaperComponent={CustomPaper}
                            getOptionLabel={(option) =>
                                option.code + " - " + option.organizationName || ""
                            }
                             onChange={(event, value) => {
                               if (value) {
                            getMenu(value.id)
                               getSite(value.id)
                                setIdInfo({ orgid: value.id, siteid: eamAdmin ? defaultInfo.site.id :null });
                            setSel({...sel, autoOrg: value.code + " - " + value.organizationName, autoSite: "", siteDetail: eamAdmin ? defaultInfo.site : null})
                               } else {
                                 setIdInfo({ orgid: null, siteid: null });
                             setSel({...sel, autoOrg: "", autoSite: "", siteDetail: null})
                            setMenusId([])
                  setBackUpMenu([])
                  setSiteId([])
                               }
                             }}
                              onInputChange={(event, newInputValue) => {
                if(eamAdmin) {
                                 setSel({ ...sel, autoOrg: newInputValue });
                            }
                            }}renderInput={(params) => (
                                <TextField
                                    {...params}
                                    name="organizationId"
                                    placeholder="Select Organization"
                                    variant="outlined"
                                    size="small"
                                    fullWidth

                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <React.Fragment>
                                                {org.length === 0 ? (
                                                    <CircularProgress color="inherit" size={20} />
                                                ) : null}
                                                {params.InputProps.endAdornment}
                                            </React.Fragment>
                                        ),
                                    }}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={4} sx={{display:eamAdmin?"none":"default"}}>
                        <Typography
                            sx={{
                                fontWeight: color.labelFontWeight,
                                mb: color.labelmb,
                                fontSize: color.labelFont,
                                color: color.labelColor,
                            }}
                        >
                            Site
                        </Typography>
                        <Autocomplete
                            fullWidth
                            // value={site.find((p) => p.id === editData.siteId) || null}
                            filterOptions={filterOptions}
                            loading={site.length === 0}
                            inputValue={sel.autoSite}
                            value={sel.siteDetail}
                            options={site}
                            PaperComponent={CustomPaper}
                            getOptionLabel={(option) =>
                                option.code + " - " + option.siteName || option
                            }
                            freeSolo
                            onChange={(event, value) => {
                                console.log(value);
                                if (value !== null) {
                                    // getMenuBySite(value.id);

                                    setIdInfo({ ...idInfo, siteid: value.id });
                                    setSel({...sel, autoSite: value.code + " - " + value.siteName,siteDetail:value})
                                    //  setFieldValue("siteId", value.id);
                                } else {
                                    // setIdInfo({ ...idInfo, siteid: null });
                                    // setSel({...sel, autoSite: "",siteDetail:null})
                                    handleCancel(false)
                                }
                            }}
                            onInputChange={(event, newInputValue) => {
                                setSel({ ...sel, autoSite: newInputValue });
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    name="siteId"
                                    placeholder="Select Site"
                                    //  onChange={handleChange}
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <React.Fragment>
                                                {/* {info.length === 0 ? <CircularProgress color="inherit" size={20} /> : null} */}
                                                {/* {site.length===0 ? (
                                                                  <CircularProgress color="inherit" size={20} />
                                                                ) : null} */}
                                                {params.InputProps.endAdornment}
                                            </React.Fragment>
                                        ),
                                    }}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <Typography
                            sx={{
                                fontWeight: color.labelFontWeight,
                                mb: color.labelmb,
                                fontSize: color.labelFont,
                                color: color.labelColor,
                            }}
                        >
                            Role
                        </Typography>
                        {/* <Select
                // label={"Select"}
                size={"small"}
                type="text"
                name="roleId"
                value={sel.selectedRole}
                fullWidth
                displayEmpty
                onChange={(e)=>{
                  setSel({...sel,selectedRole:e.target.value})
                }}
                MenuProps={{ PaperProps: { sx: { maxHeight: "40vh" } } }}
               renderValue={sel.selectedRole !== "" ? undefined : () =><Typography sx={{  color: color.placeholderColor,
                fontSize: "13px",}} >Select</Typography> }
              >

                {rolesId.map((id, i) => (
                  <MenuItem value={id.id}>{id.name}</MenuItem>
                ))}
              </Select> */}
                        <Autocomplete
                            // value={remedySelect}
                            inputValue={sel.autoRole}
                            value={sel.roleDetail}
                            fullWidth
                            filterOptions={filterOptions}
                            loading={rolesId.length === 0}
                            options={rolesId}
                            PaperComponent={CustomPaper}
                            getOptionLabel={(option) => option.name}
                            getOptionDisabled={(option) => (eamAdmin&&(option.id===defaultInfo.OrgAdmin.id))?true:false}
                            freeSolo
                            onChange={(event, value) => {
                                console.log(value);
                                if (value !== null) {
                                    handleRoleMenu(value);
                                } else {
                                    // setSel({
                                    //   ...sel,
                                    //   selectedRole: "",
                                    //   autoRole: "",
                                    //   roleDetail: null,
                                    // });
                                    handleCancel(eamAdmin?false:true)
                                }
                            }}
                            onInputChange={(event, newInputValue) => {
                                setSel({ ...sel, autoRole: newInputValue });
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    placeholder="Select Role"
                                    //  onChange={handleChange}
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <React.Fragment>
                                                {/* {info.length === 0 ? <CircularProgress color="inherit" size={20} /> : null} */}
                                                {rolesId.length === 0 ? (
                                                    <CircularProgress color="inherit" size={20} />
                                                ) : null}
                                                {params.InputProps.endAdornment}
                                            </React.Fragment>
                                        ),
                                    }}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <NormalTable
                            data={
                                isSystemAccess(login)
                                    ? menusId
                                    : menusId.filter((menu) => menu.id !== SubMenu.systemMenu)
                            }
                            columns={columns}
                            filt={true}
                        />
                    </Grid>
                    <Grid container item xs={12} justifyContent={"flex-end"} gap="1rem">
                        <Button
                            onClick={handleCancel}
                            variant="contained"
                            sx={{
                                backgroundColor: color.TableCancelButton,
                                textTransform: "none",
                                color: color.CancelTextColor,
                                ":hover": {
                                    backgroundColor: color.TableCancelButton,
                                    textTransform: "none",
                                    color: color.CancelTextColor,
                                },
                            }}
                        >
                            Clear
                        </Button>
                        <Button
                            type={"submit"}
                            variant="contained"
                            disabled={loading}
                            onClick={handleSubmit}
                            sx={{
                                textTransform: "none",
                                backgroundColor: loading ? "default" : color.TableButtonColor,
                                "&:hover": {
                                    backgroundColor: loading ? "default" : color.buttonDisable,
                                },
                            }}
                        >
                            Submit
                        </Button>
                    </Grid>
                </Grid>
            </Paper>
        </>
    );
};

export default RoleMenu;
